package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.GmInventoryItem
import fr.manyverse.app.domain.repository.GmInventoryRepository

class GetGmInventoryItemsUseCase(
    private val gmInventoryRepository: GmInventoryRepository
) {
    suspend operator fun invoke(tableId: String): Result<List<GmInventoryItem>> {
        return gmInventoryRepository.getItemsForTable(tableId)
    }
}
